export const TAB_COLUMNS_INDEX = 0;
export const TAB_ACTION_INDEX = 1;
export const TAB_DISTRIBUTION_INDEX = 2;

export const COLUMNS_COLUMN = 'fieldName';
export const COLUMNS_SHOW_IN_GRID = 'showInGrid';
export const COLUMNS_IS_NAVIGATION_COLUMN = 'isNavigationColumn';
export const COLUMNS_TRANSLATE_DATA = 'translateData';
export const COLUMNS_DATA_TYPE = 'fieldDataType';

export const SEARCH_CRITERIA_COLUMN = 'fieldName';
export const SEARCH_CRITERIA_OPEN_GROUP = 'openGroup';
export const SEARCH_CRITERIA_CLOSE_GROUP = 'closeGroup';
export const SEARCH_CRITERIA_RELATION_OPERATOR = 'relOperator';
export const SEARCH_CRITERIA_OPERATOR = 'sqlOperator';
export const SEARCH_CRITERIA_VALUE = 'value';
export const SEARCH_CRITERIA_IS_EDIT_ALLOWED = 'allowEditing';
export const SEARCH_CRITERIA_ENABLE_LOOKUP = 'enableLookup';

export const SORT_COLUMN = 'fieldName';
export const SORT_ORDER = 'sortOrder';

export const ACTIONS_TEMPLATE = 'actionTemplate';
export const ACTIONS_URL = 'url';

export const SAVED_SEARCH_SORT = 'sort';
export const SAVED_SEARCH_COLUMNS = 'columns';
export const SAVED_SEARCH_CRITERIA = 'searchCriteria';
export const SAVED_SEARCH_ACTION = 'actions';

export const SAVED_SEARCH_SORT_TABLE_LABEL = 'Sort';
export const SAVED_SEARCH_COLUMNS_TABLE_LABEL = 'Columns';
export const SAVED_SEARCH_CRITERIA_TABLE_LABEL = 'Search Criteria';
export const SAVED_SEARCH_DISTRIBUTION_TABLE_LABEL = 'Distribution';
export const SAVED_SEARCH_ACTION_TABLE_LABEL = 'Action';

export const SEARCH_CRITERIA_VALUE_OPTIONS = [
  '{UserContext.ActorCode}',
  '{UserContext.ActorOrgUnitCode}',
  '{UserContext.ActorSiteCode}',
  '{UserContext.ActorOrgUnit1Code}',
  '{UserContext.ActorOrgUnit2Code}',
  '{UserContext.ActorOrgUnit3Code}',
  'AddDays(0)',
  '{|Param1|}',
];

export const SORT_ORDER_OPTIONS = [
  {
    label: 'Ascending',
    value: 'ASC',
  },
  {
    label: 'Descending',
    value: 'DESC',
  },
];

export const SQL_OPERATORS_OPTIONS = [
  {
    label: 'And',
    value: 'and',
  },
  {
    label: 'Or',
    value: 'or',
  },
];

export const SEARCH_CRITERIA_OPEN_GROUP_OPTIONS = [
  {
    label: '',
    value: false,
  },
  {
    label: '(',
    value: true,
  },
];

export const SEARCH_CRITERIA_CLOSE_GROUP_OPTIONS = [
  {
    label: '',
    value: false,
  },
  {
    label: ')',
    value: true,
  },
];

export const RELATIONAL_OPERATORS = [
  {
    id: 'EQ',
    value: 'EQ',
    label: 'Is Equal To',
  },
  {
    id: 'LT',
    value: 'LT',
    label: 'Is Less Than',
  },
  {
    id: 'LTEQ',
    value: 'LTEQ',
    label: 'Is Less Than or Equal To',
  },
  {
    id: 'GT',
    value: 'GT',
    label: 'Is Greater Than',
  },
  {
    id: 'GTEQ',
    value: 'GTEQ',
    label: 'Is Greater Than or Equal To',
  },
  {
    id: 'NEQ',
    value: 'NEQ',
    label: 'Not Equal To',
  },
  {
    id: 'ISNULL',
    value: 'ISNULL',
    label: 'Is Null',
  },
  {
    id: 'ISNOTNULL',
    value: 'ISNOTNULL',
    label: 'Is Not Null',
  },
  {
    id: 'SW',
    value: 'SW',
    label: 'Starts With',
  },
  {
    id: 'EW',
    value: 'EW',
    label: 'Ends With',
  },
  {
    id: 'CT',
    value: 'CT',
    label: 'Contains',
  },
];

export const MAX_ACTIONS_TABLE_ROWS_COUNT = 1;

export const MOVE_TABLE_ROW_UP = 'MOVE_TABLE_ROW_UP';
export const MOVE_TABLE_ROW_DOWN = 'MOVE_TABLE_ROW_DOWN';

export const ACTION_TEMPLATE_DETAIL = 'Detail';

export const SUPPORTED_SAVED_SEARCH_ACTIONS = [ACTION_TEMPLATE_DETAIL];

export const DEFAULT_URL_TEMPLATE_OPTIONS = [
  {
    label: 'Detail',
    value: 'entity-display?entityName={0}&itmId={|PK_ID|}&entityType={0}&formKey={0}_DETAIL',
  },
  {
    label: 'Step',
    value:
      'entity-display?itmId={|WFE_RECORD_ID|}&entityType={|WFE_ENTITY_NAME|}&workFlowId={|WFE_ID|}&stepId={|WFT_ID|}&formKey={|WFE_ENTITY_NAME|}_DETAIL',
  },
];

export const MAX_SAVED_SEARCH_NAME_LENGTH = 100;

export const SEARCH_NAME_VALIDATION_ERROR_MESSAGES = {
  MAX_LENGTH: `Saved Search Name cannot be greater than ${MAX_SAVED_SEARCH_NAME_LENGTH} characters`,
  REQUIRED: 'Saved Search Name is required',
  SPECIAL_CHARACTERS: 'Saved Search Name cannot contain special characters',
  UNIQUE: 'Saved Search Name is not unique',
};

export const SAVE_ACTIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  SAVE_AS: 'saveAs',
};
